// @ts-ignore
/* eslint-disable */
import request from "../../utils/request";

/** 获取OSS配置信息 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /oss/config */
export async function ossConfigUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultAssumeRoleResponse>("/oss/config", {
    method: "GET",
    ...(options || {}),
  });
}

/** oss上传临时凭证 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /oss/token/${param0} */
export async function ossTokenIsVideoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.ossTokenIsVideoUsingGETParams,
  options?: { [key: string]: any }
) {
  const { isVideo: param0, ...queryParams } = params;
  return request<API.BaseResultOssTokenResp>(`/oss/token/${param0}`, {
    method: "GET",
    params: { ...queryParams },
    ...(options || {}),
  });
}
